<style scoped>
.bg {
  background: url('~@/assets/images/unauth/bg.jpeg') rgba(3, 31, 53, 0.1);
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: multiply;
}
</style>

<template >
  <v-app class="bg">
    <v-content>
      <v-container class="fill-height" fluid>
        <slot />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'BaseUnauth',
};
</script>
